import { render, staticRenderFns } from "./ReferenciasTable.vue?vue&type=template&id=54880e92&"
import script from "./ReferenciasTable.vue?vue&type=script&lang=js&"
export * from "./ReferenciasTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports